export default "__VITE_ASSET__5cb1830a__"